import React, { useMemo } from "react";
import SettlementManagementLayout from "@/features/my-order/features/settlement-management/components/SettlementManagementLayout";
import SettlementManagementCreditSupplierSelectSection from "@/features/my-order/features/settlement-management/components/credit/SettlementManagementCreditSupplierSelectSection";
import SettlementManagementCreditMainSection from "@/features/my-order/features/settlement-management/components/credit/SettlementManagementCreditMainSection";
import useGetCreditInvoiceList from "@/features/my-order/features/settlement-management/hooks/query/useGetCreditInvoiceList";
import CenteredSpinner from "@/shared/components/centered-spinner";
import { Box } from "@chakra-ui/react";
import useSettlementManagementQuery from "@/features/my-order/features/settlement-management/hooks/useSettlementManagementQuery";
import { GetCreditInvoiceListRequest } from "@/features/my-order/features/settlement-management/types";
import NoResultSimple from "@/shared/components/no-result-simple";
import { useTranslation } from "react-i18next";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function SettlementManagementCreditContent() {
  const { tSentence } = useI18nHelper();
  const { query } = useSettlementManagementQuery();
  const { data, isPending } = useGetCreditInvoiceList();
  const boutiqueList = useMemo(
    () =>
      data?.statistics?.byBoutique
        .slice()
        .sort((curr, next) => next.totalAmount - curr.totalAmount) ?? [],
    [data]
  );
  const selectedBoutiqueId =
    query["issuedByCompany.id__eq"] ?? boutiqueList[0]?.boutiqueId;
  const selectedBoutique = useMemo(
    () => boutiqueList.find((item) => item.boutiqueId === selectedBoutiqueId),
    [boutiqueList, selectedBoutiqueId]
  );
  const creditListParams = useMemo<GetCreditInvoiceListRequest>(
    () => ({
      ...query,
      "issuedByCompany.id__eq": selectedBoutiqueId,
    }),
    [query, selectedBoutiqueId]
  );

  if (isPending) return <CenteredSpinner />;

  return (
    <Box flex={1} minHeight={0}>
      {boutiqueList.length > 0 ? (
        <SettlementManagementLayout
          leftSideComponent={
            <SettlementManagementCreditSupplierSelectSection
              boutiqueList={boutiqueList}
              selectedBoutiqueId={selectedBoutiqueId}
            />
          }
          rightSideComponent={
            <SettlementManagementCreditMainSection
              selectedBoutique={selectedBoutique}
              creditListParams={creditListParams}
              isCreditListEnabled={selectedBoutiqueId !== undefined}
            />
          }
        />
      ) : (
        <NoResultSimple
          size={"48px"}
          text={tSentence("settlement:credit_no_result_description")}
          textStyle={"body-lg-regular"}
          gap={"16px"}
        />
      )}
    </Box>
  );
}

export default SettlementManagementCreditContent;
